import { useStore } from 'vuex';
import _ from 'lodash-es';

export default function useEmailValidation() {
  const store = useStore();

  async function isEmailUnique(email_address) {
    if (email_address === '' || _.isNil(email_address)) return true;

    try {
      const results = await Promise.all([
        store.dispatch('AUTOCOMPLETE_CUSTOMERS', { user_email_address_eq: email_address }),
        store.dispatch('AUTOCOMPLETE_EMPLOYEES', { user_email_address_eq: email_address }),
        store.dispatch('AUTOCOMPLETE_LEADS', { user_email_address_eq: email_address }),
        store.dispatch('AUTOCOMPLETE_PARTNERS', { user_email_address_eq: email_address }),
      ]);

      return _.isEmpty(results.flat());
    } catch {
      return true;
    }
  }

  return { isEmailUnique };
}
